import script from "./Chat.vue?vue&type=script&lang=ts&setup=true"
export * from "./Chat.vue?vue&type=script&lang=ts&setup=true"

import "./Chat.vue?vue&type=style&index=0&id=9d716834&scoped=true&lang=css"
import "./Chat.vue?vue&type=style&index=1&id=9d716834&lang=css"
/* custom blocks */
import block0 from "./Chat.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d716834"]])

export default __exports__